import React from 'react';

import { bool, string, shape, node, oneOfType, arrayOf } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './Overlay.scss';

/**
 * @deprecated
 */
export default class Overlay extends BaseComponent {
  handleClick = e => {
    const { onClick } = this.props;

    if (onClick) {
      onClick(e.target.value);
    }
  };

  render() {
    const { show, className, id, style, children } = this.props;

    const classNames = ClassNames('Overlay', { show }, className);

    return (
      <div id={id} style={style} className={classNames}>
        {children}
      </div>
    );
  }
}

Overlay.propTypes = {
  show: bool,
  className: string,
  id: string,
  style: shape({}),
  children: oneOfType([arrayOf(node), node])
};

Overlay.defaultProps = {
  show: false,
  className: undefined,
  id: undefined,
  style: {}
};
